import getApiClient from '@/plugins/api-client'

export default {
    loadPosts: function() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('posts')
            .then(result => {
                self.posts = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },

    editPost: function(postId) {
        this.$router.push(`/posts/edit/${postId}`)
    },

    showDeleteConfirmation(id) {
        this.deletePost = id

        this.showDeleteConfirmationModal = true
    },

    confirmDeletePost() {
        const self = this,
          api = getApiClient(self.$store),
          id = self.deletePost

        api.delete(`posts/${id}`)
          .then(() => {
              self.deleteBanner = null
              self.loadPosts()
              self.showDeleteConfirmationModal = false
          })
          .catch(error => {
              console.log(error)
          })
    },

    cancelDeleteModal() {
        this.deletePost = null
        this.showDeleteConfirmationModal = false
    },
}
